import { render, staticRenderFns } from "./ProjectList.vue?vue&type=template&id=4bdf130c&"
import script from "./ProjectList.vue?vue&type=script&lang=js&"
export * from "./ProjectList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bdf130c')) {
      api.createRecord('4bdf130c', component.options)
    } else {
      api.reload('4bdf130c', component.options)
    }
    module.hot.accept("./ProjectList.vue?vue&type=template&id=4bdf130c&", function () {
      api.rerender('4bdf130c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/ProjectList.vue"
export default component.exports